import moment from 'moment';

export default function getSortComparator(field: string) {
    if (field === 'date')
        return (v1: any, v2: any) => {
            const format = 'HH:mm DD.MM.YYYY';
            const a = moment(v1, format).valueOf();
            const b = moment(v2, format).valueOf();
            return a - b;
        };
    else
        return (v1: any, v2: any) => {
            if (typeof v1 === 'string' && typeof v2 === 'string') {
                return v1.localeCompare(v2);
            } else return v1 - v2;
        };
}
